module.exports = __webpack_public_path__ + "static/img/mo_btn2.beb2492.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/role3/control/mo_btn2.png
// module id = NQwX
// module chunks = 7